import Vue from 'vue';
import VueRouter from 'vue-router';
import {
  PageNotFound,
  Forbidden,
  InternalServerError,
  BadGateway,
} from '@bizfly/shared';
import Layout from '@/layout';
import i18n from '@/utils/i18n';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/index'),
        meta: { title: i18n.t('title'), auth: true },
      },
    ],
  },
  {
    path: '/500',
    name: 'InternalServerError',
    component: InternalServerError,
    meta: {
      title: '500',
    },
  },
  {
    path: '/502',
    name: 'BadGateway',
    component: BadGateway,
    meta: {
      title: '502',
    },
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: Forbidden,
    meta: {
      title: '403',
    },
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      title: '404',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes,
});

export default router;
